import type { CSSProperties, ReactNode } from "react";

export function Eyebrow({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <div
      style={{
        font: "var(--type-eyebrow)",
        color: "var(--muted)",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
